var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.divClass},[_c('strong',[_vm._v(_vm._s(_vm.label)+_vm._s(_vm.showDoubleDot ? ':' : '')+" ")]),_c('span',[_vm._v(_vm._s(_vm.value || _vm.withoutInformation))])])
}
var staticRenderFns = []

export { render, staticRenderFns }